import React from 'react';
// import PostCard from '../components/Blog/PostCard';

// function Posts() {
//   return (
//     <div className="post-card-grid">
//       <PostCard
//         genre="You dont need"
//         title="Microservices to scale early"
//         summary="Why early teams benefit from a focused architecture before distributing systems."
//         to="/blog/test"
//       />
//     </div>
//   );
// }

function Blog() {
  return (
    <section className="page blog-index-page">
      <h1>Posts</h1>
      <p>Thoughts on engineering, product, and building with intention.</p>

    </section>
  );
}

export default Blog;
